var React = require('react');

function Portfolio (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M61 0h182.515c27.097 0 52.53 2.684 76.304 8.052 23.773 5.368 44.478 14.315 62.117 26.84 17.638 12.526 31.57 29.142 41.794 49.847 10.225 20.706 15.337 46.14 15.337 76.304 0 29.141-5.24 54.448-15.72 75.92-10.481 21.473-24.668 39.11-42.562 52.914-17.893 13.804-38.599 24.029-62.116 30.675-23.518 6.646-48.569 9.97-75.154 9.97H173.73V500H61V0zm175.613 240.798c60.84 0 91.258-26.585 91.258-79.755 0-26.074-7.668-44.479-23.006-55.215-15.337-10.736-38.088-16.104-68.252-16.104H173.73v151.074h62.883z","fillRule":"evenodd","fill":"currentColor"}));
}

Portfolio.defaultProps = {"width":"500","height":"500","viewBox":"0 0 500 500"};

module.exports = Portfolio;

Portfolio.default = Portfolio;
